/* brand-carousel.js */
(function () {
    const init = (root) => {
        if (!root || root.dataset.bcInit === 'true') return;
        root.dataset.bcInit = 'true';

        const config = JSON.parse(root.querySelector('[data-bc-config]').textContent);

        const track = root.querySelector('.bc-track');
        let cards = Array.from(root.querySelectorAll('.bc-card'));
        let total = cards.length;
        if (total < 1) return;

        // Helper: Modulo that handles negatives correctly
        const mod = (n, m) => ((n % m) + m) % m;

        // Ensure we have at least 7 cards for smooth 3D carousel effect
        if (total > 0 && total < 7) {
            const originalCards = [...cards];
            while (cards.length < 7) {
                originalCards.forEach(orig => {
                    const clone = orig.cloneNode(true);
                    clone.classList.remove('bc-card-active', 'bc-card-prev', 'bc-card-next', 'bc-card-prev2', 'bc-card-next2');
                    track.appendChild(clone);
                    cards.push(clone);
                });
            }
            total = cards.length;
        }

        let current = 0;

        const cls = {
            active: 'bc-card-active',
            prev: 'bc-card-prev',
            next: 'bc-card-next',
            prev2: 'bc-card-prev2',
            next2: 'bc-card-next2'
        };
        const allCls = Object.values(cls);

        const render = () => {
            cards.forEach((card, i) => {
                allCls.forEach(c => card.classList.remove(c));
                const diff = mod(i - current, total);

                if (diff === 0) {
                    card.classList.add(cls.active);
                } else if (diff === 1) {
                    card.classList.add(cls.next);
                } else if (diff === total - 1) {
                    card.classList.add(cls.prev);
                } else if (diff === 2) {
                    card.classList.add(cls.next2);
                } else if (diff === total - 2) {
                    card.classList.add(cls.prev2);
                }
            });
        };

        const goTo = (index) => {
            current = mod(index, total);
            render();
        };

        // Card click event
        cards.forEach((card, i) => {
            card.addEventListener('click', () => {
                if (i !== current) { goTo(i); }
            });
        });

        const prevBtn = root.querySelector('.bc-nav-prev');
        const nextBtn = root.querySelector('.bc-nav-next');
        if (prevBtn) prevBtn.addEventListener('click', () => { goTo(current - 1); });
        if (nextBtn) nextBtn.addEventListener('click', () => { goTo(current + 1); });

        let touchStartX = 0;
        root.addEventListener('touchstart', (e) => { touchStartX = e.changedTouches[0].screenX; }, { passive: true });
        root.addEventListener('touchend', (e) => {
            const diff = touchStartX - e.changedTouches[0].screenX;
            if (Math.abs(diff) > 40) { goTo(diff > 0 ? current + 1 : current - 1); }
        }, { passive: true });

        render();
    };

    const roots = document.querySelectorAll('[data-bc-root]');
    roots.forEach(init);

    document.addEventListener('shopify:section:load', (e) => {
        const root = e.target.querySelector('[data-bc-root]');
        if (root) init(root);
    });
})();

